module.exports = __webpack_public_path__ + "media/components/assets/icons/credit_card-d1839a9a58cc72b4274029e0a0817501.svg";